import { Typography } from '@mui/material';
import { SimpleSelect } from '@prismamedia/one-components';
import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import {
  useGetPrintIssues,
  useGetPrintPublications,
} from './issuePage.topic.graphql';

export const IssueSelector: FC<{
  selectedIssue: string | undefined;
  setSelectedIssue: Dispatch<SetStateAction<string | undefined>>;
}> = ({ selectedIssue, setSelectedIssue }) => {
  const [selectedPrintPublication, setSelectedPrintPublication] = useState<
    string | undefined
  >(undefined);

  const {
    data: printPublicationsData,
    error: printPublicationsError,
  } = useGetPrintPublications({
    first: 1000,
  });

  const { data: printIssuesData, error: printIssuesError } = useGetPrintIssues(
    {
      first: 1000,
      where: { printPublication: { id: selectedPrintPublication } },
    },
    !selectedPrintPublication,
  );

  const error = printIssuesError || printPublicationsError;

  useEffect(() => {
    if (!selectedIssue || !printPublicationsData) return;
    setSelectedPrintPublication(
      printPublicationsData.printPublications.find((printPublication) =>
        printPublication.printIssues
          .map(({ id }) => id)
          .includes(selectedIssue),
      )?.id,
    );
  }, [printPublicationsData, selectedIssue]);

  if (error) {
    return <Typography color="error">{error.message}</Typography>;
  }

  return (
    <>
      <SimpleSelect
        label="Magazine"
        size="small"
        value={selectedPrintPublication || ''}
        sx={{ minWidth: 150 }}
        onChange={(_, printPublication) => {
          setSelectedPrintPublication(printPublication || undefined);
          setSelectedIssue(undefined);
        }}
        options={[
          { value: '', label: '-' },
          // eslint-disable-next-line fp/no-mutating-methods
          ...[...(printPublicationsData?.printPublications || [])]
            .sort((a, b) => a.title.localeCompare(b.title))
            .map(({ id, title }) => ({
              value: id,
              label: title,
            })),
        ]}
      />
      <SimpleSelect
        label="Parution"
        size="small"
        disabled={!selectedPrintPublication}
        value={selectedIssue || ''}
        sx={{ minWidth: 150, ml: 2 }}
        onChange={(_, printIssue) => {
          setSelectedIssue(printIssue || undefined);
        }}
        options={[
          { value: '', label: '-' },
          // eslint-disable-next-line fp/no-mutating-methods
          ...[...(printIssuesData?.printIssues || [])]
            .sort((issueA, issueB) => {
              return issueB.title.localeCompare(issueA.title, undefined, {
                numeric: true,
                sensitivity: 'base',
              });
            })
            .map(({ id, title }) => ({
              value: id,
              label: title,
            })),
        ]}
      />
    </>
  );
};
